<span fxLayout="row" fxFlex="100" fxLayoutAlign="center start">
  <span
    fxLayout="column"
    class="position-relative lane-body"
    fxFlex="0 1 900px"
    fxFlex.xs="100"
    fxFlex.sm="100"
  >
    <span fxLayout="column" fxLayoutAlign="start start">
      <h2
        class="res-pad-lr-0-20 mat-headline-1 primary-color mb10px"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFill
        >{{ title }}</h2>
      <span
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFill
        [fxLayoutGap]="boxGapPx + 'px'"
        class="scrollbar-off no-vertical-scroll"
        #scrollContainer
      >
        <div
        class="res-width-0-5 mobile-only"></div>
        <a
          [routerLink]="['/']"
          [queryParams]="{ src: b.channelId }"
          *ngFor="let b of channels"
          [ngStyle]="{ 'width.px': boxWidthPx,  'height.px': boxWidthPx }"
        >
          <img
            height="80"
            width="80"
            class="box text-center clickable"
            [ngStyle]="{ 'width.px': boxWidthPx }"
            [src]="b.assetLink"
            [alt]="getAltTranslationString(b.channelId) | translate"
            loading="lazy"
            fetchprioritiy="low"
        /></a>
        <div
          class="res-width-0-20 mobile-only"
          [innerHTML]="'&nbsp;'"
        ></div>
      </span>
    </span>
    <img
      src="assets/media/hover_arrows_hero_left.svg"
      *ngIf="leftVisible()"
      class="left-pos clickable"
      (click)="scrollLeft(scrollContainer)"
      height="48"
      width="31"
      [alt]="'common.left' | translate"
      loading="lazy"
      fetchprioritiy="low"
    />
    <img
      src="assets/media/hover_arrows_hero_right.svg"
      *ngIf="rightVisible()"
      class="right-pos clickable"
      (click)="scrollRight(scrollContainer)"
      height="48"
      width="30"
      [alt]="'common.right' | translate"
      loading="lazy"
      fetchprioritiy="low"
    />
  </span>
</span>
